import * as React from 'react'

import { theme } from '@procurify/ui-theme'

import { type IIconButtonProps } from './IconButton'
import { TransparentIconButtonStyled } from './styles/TransparentIconButtonStyled'
import { Icon, type IIconProps } from '../Icon'
import { CircleLoader } from '../Loaders'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'

export interface ITransparentIconButtonProps extends IIconButtonProps {
  iconColor?: IIconProps['color']
}

export const TransparentIconButton = ({
  htmlTitle,
  onClick,
  isLoading,
  iconComponent,
  icon,
  disabled,
  iconColor = theme.colors.text.primary as keyof (typeof theme)['colors'],
  analyticsId,
  ...otherProps
}: ITransparentIconButtonProps) => {
  const analyticsProps = getAnalyticsDataAttrs(analyticsId)

  return (
    <TransparentIconButtonStyled
      title={htmlTitle}
      onClick={!isLoading ? onClick : undefined}
      isLoading={isLoading}
      disabled={disabled || isLoading}
      {...analyticsProps}
      {...otherProps}
    >
      {!isLoading ? (
        iconComponent ? (
          iconComponent
        ) : (
          <Icon icon={icon} color={iconColor} />
        )
      ) : (
        <CircleLoader size={14} color={iconColor} />
      )}
    </TransparentIconButtonStyled>
  )
}
